/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/restrictions/general-settings/general-settings.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import10 from '../../../../../../public/upgrade/core/session.service';
import * as import11 from '../../../../../../public/upgrade/feature/restrictions/modal-general-settings/modal-general-settings.component';
import * as import12 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import13 from '../modal-general-settings/modal-general-settings.component.ngfactory';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import17 from '@angular/forms/src/form_builder';
import * as import18 from '../../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import19 from '../../../../../../public/upgrade/root/form-modal/form-modal.component';
import * as import20 from '../../../root/form-modal/form-modal.component.ngfactory';
import * as import21 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '@ngx-translate/core/src/translate.pipe';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@ngx-translate/core/src/translate.service';
import * as import25 from '@angular/common/src/directives/ng_if';
export class Wrapper_GeneralSettingsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.GeneralSettingsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.GeneralSettingsComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_generalValues(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.generalValues = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.updateGeneralRestriction.subscribe(_eventHandler.bind(view,'updateGeneralRestriction'))); }
  }
}
var renderType_GeneralSettingsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_GeneralSettingsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.GeneralSettingsComponent>;
  _GeneralSettingsComponent_0_3:Wrapper_GeneralSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_GeneralSettingsComponent_Host0,renderType_GeneralSettingsComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'general-settings',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_GeneralSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._GeneralSettingsComponent_0_3 = new Wrapper_GeneralSettingsComponent(this.injectorGet(import9.FormModalService,this.parentIndex),this.injectorGet(import10.SessionService,this.parentIndex));
    this.compView_0.create(this._GeneralSettingsComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._GeneralSettingsComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.GeneralSettingsComponent) && (0 === requestNodeIndex))) { return this._GeneralSettingsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._GeneralSettingsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._GeneralSettingsComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const GeneralSettingsComponentNgFactory:import8.ComponentFactory<import0.GeneralSettingsComponent> = new import8.ComponentFactory<import0.GeneralSettingsComponent>('general-settings',View_GeneralSettingsComponent_Host0,import0.GeneralSettingsComponent);
const styles_GeneralSettingsComponent:any[] = ([] as any[]);
class View_GeneralSettingsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import11.ModalGeneralSettingsComponent>;
  _GAService_2_3:import12.GAService;
  _ModalGeneralSettingsComponent_2_4:import13.Wrapper_ModalGeneralSettingsComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_GeneralSettingsComponent1,renderType_GeneralSettingsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'modal-general-settings',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import13.View_ModalGeneralSettingsComponent0(this.viewUtils,this,2,this._el_2);
    this._GAService_2_3 = new import12.GAService();
    this._ModalGeneralSettingsComponent_2_4 = new import13.Wrapper_ModalGeneralSettingsComponent(this.parentView.parentView.injectorGet(import15.ActivatedRoute,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import16.NotificationService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import17.FormBuilder,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import9.FormModalService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import18.RestrictionsService,this.parentView.parentIndex),this._GAService_2_3);
    this.compView_2.create(this._ModalGeneralSettingsComponent_2_4.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'updateGeneralSetting',(null as any)),this.eventHandler(this.handleEvent_2));
    this._ModalGeneralSettingsComponent_2_4.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.GAService) && (2 === requestNodeIndex))) { return this._GAService_2_3; }
    if (((token === import11.ModalGeneralSettingsComponent) && (2 === requestNodeIndex))) { return this._ModalGeneralSettingsComponent_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.generalValues;
    this._ModalGeneralSettingsComponent_2_4.check_generalValues(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.openModal;
    this._ModalGeneralSettingsComponent_2_4.check_openModal(currVal_2_0_1,throwOnChange,false);
    this._ModalGeneralSettingsComponent_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._ModalGeneralSettingsComponent_2_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'updateGeneralSetting')) {
      const pd_sub_0:any = ((<any>this.parentView.context.updateGeneralSetting($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_GeneralSettingsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_GeneralSettingsComponent,{});
export class View_GeneralSettingsComponent0 extends import2.AppView<import0.GeneralSettingsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _el_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _el_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _text_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _el_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _el_75:any;
  _text_76:any;
  _el_77:any;
  _text_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _text_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _el_92:any;
  compView_92:import2.AppView<import19.FormModalComponent>;
  _FormModalComponent_92_3:import20.Wrapper_FormModalComponent;
  _text_93:any;
  _anchor_94:any;
  /*private*/ _vc_94:import14.ViewContainer;
  _TemplateRef_94_5:any;
  _NgIf_94_6:import21.Wrapper_NgIf;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  /*private*/ _expr_103:any;
  _pipe_translate_0:import22.TranslatePipe;
  /*private*/ _expr_105:any;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_107:any;
  _pipe_translate_2:import22.TranslatePipe;
  /*private*/ _expr_109:any;
  _pipe_translate_3:import22.TranslatePipe;
  /*private*/ _expr_111:any;
  _pipe_translate_4:import22.TranslatePipe;
  /*private*/ _expr_113:any;
  _pipe_translate_5:import22.TranslatePipe;
  _pipe_translate_6:import22.TranslatePipe;
  /*private*/ _expr_116:any;
  _pipe_translate_7:import22.TranslatePipe;
  _pipe_translate_8:import22.TranslatePipe;
  /*private*/ _expr_119:any;
  _pipe_translate_9:import22.TranslatePipe;
  _pipe_translate_10:import22.TranslatePipe;
  /*private*/ _expr_122:any;
  /*private*/ _expr_123:any;
  _pipe_translate_11:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_GeneralSettingsComponent0,renderType_GeneralSettingsComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_103 = import1.UNINITIALIZED;
    this._expr_105 = import1.UNINITIALIZED;
    this._expr_107 = import1.UNINITIALIZED;
    this._expr_109 = import1.UNINITIALIZED;
    this._expr_111 = import1.UNINITIALIZED;
    this._expr_113 = import1.UNINITIALIZED;
    this._expr_116 = import1.UNINITIALIZED;
    this._expr_119 = import1.UNINITIALIZED;
    this._expr_122 = import1.UNINITIALIZED;
    this._expr_123 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-table'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','table-container'),(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_24,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-bold-left table-nav-arrow-first'),(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-bold-right table-nav-arrow-last'),(null as any));
    this._text_27 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_24,'table',new import3.InlineArray4(4,'class','table-tag','id','table-restrictions-general'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'thead',new import3.InlineArray2(2,'class','table-head'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'tr',new import3.InlineArray2(2,'class','table-heading'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_34,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'',(null as any));
    this._text_37 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_32,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_38,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'',(null as any));
    this._text_41 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_32,'th',new import3.InlineArray2(2,'class','-eva-3-tl table-col table-heading-col'),(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_42,'span',new import3.InlineArray2(2,'class','table-content'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'',(null as any));
    this._text_45 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_46 = import3.createRenderElement(this.renderer,this._el_32,'th',new import3.InlineArray2(2,'class','-eva-3-tr table-heading-col'),(null as any));
    this._text_47 = this.renderer.createText(this._el_32,'\n                        ',(null as any));
    this._text_48 = this.renderer.createText(this._el_30,'\n                    ',(null as any));
    this._text_49 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_28,'tbody',new import3.InlineArray2(2,'class','table-body'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n                        ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_50,'tr',new import3.InlineArray2(2,'class','table-row'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_52,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','minAnticipationDays'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'',(null as any));
    this._text_56 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_52,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','minRentalLegth'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'',(null as any));
    this._text_59 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_52,'td',new import3.InlineArray4(4,'class','-eva-3-tl table-col','qadata','maxRentalLength'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'',(null as any));
    this._text_62 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_52,'td',new import3.InlineArray4(4,'class','-eva-3-tr table-col','style','overflow: inherit'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n                                ',(null as any));
    this._el_65 = import3.createRenderElement(this.renderer,this._el_63,'div',new import3.InlineArray4(4,'class','eva-3-tooltip -top -left -sm','style','position: absolute; right: 32px; top: 62px;'),(null as any));
    this._text_66 = this.renderer.createText(this._el_65,'\n                                    ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_65,'button',new import3.InlineArray2(2,'class','eva-3-link'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'\n                                        ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_67,'i',new import3.InlineArray2(2,'class','eva-3-icon-edit -eva-3-icon-sm'),(null as any));
    this._text_70 = this.renderer.createText(this._el_67,'\n                                        ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_67,'span',new import3.InlineArray2(2,'class','tooltip-container'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n                                            ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_74 = this.renderer.createText(this._el_71,'\n                                            ',(null as any));
    this._el_75 = import3.createRenderElement(this.renderer,this._el_71,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_76 = this.renderer.createText(this._el_75,'\n                                                ',(null as any));
    this._el_77 = import3.createRenderElement(this.renderer,this._el_75,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_78 = this.renderer.createText(this._el_77,'',(null as any));
    this._text_79 = this.renderer.createText(this._el_75,'\n                                            ',(null as any));
    this._text_80 = this.renderer.createText(this._el_71,'\n                                        ',(null as any));
    this._text_81 = this.renderer.createText(this._el_67,'\n                                    ',(null as any));
    this._text_82 = this.renderer.createText(this._el_65,'\n                                ',(null as any));
    this._text_83 = this.renderer.createText(this._el_63,'\n                            ',(null as any));
    this._text_84 = this.renderer.createText(this._el_52,'\n                        ',(null as any));
    this._text_85 = this.renderer.createText(this._el_50,'\n                    ',(null as any));
    this._text_86 = this.renderer.createText(this._el_28,'\n                ',(null as any));
    this._text_87 = this.renderer.createText(this._el_24,'\n            ',(null as any));
    this._text_88 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._text_89 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_90 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._text_91 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_92 = import3.createRenderElement(this.renderer,this._el_0,'form-modal',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_92 = new import20.View_FormModalComponent0(this.viewUtils,this,92,this._el_92);
    this._FormModalComponent_92_3 = new import20.Wrapper_FormModalComponent(this.parentView.injectorGet(import9.FormModalService,this.parentIndex));
    this._text_93 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._anchor_94 = this.renderer.createTemplateAnchor((null as any),(null as any));
    this._vc_94 = new import14.ViewContainer(94,92,this,this._anchor_94);
    this._TemplateRef_94_5 = new import23.TemplateRef_(this,94,this._anchor_94);
    this._NgIf_94_6 = new import21.Wrapper_NgIf(this._vc_94.vcRef,this._TemplateRef_94_5);
    this._text_95 = this.renderer.createText((null as any),'\n    ',(null as any));
    this.compView_92.create(this._FormModalComponent_92_3.context);
    this._text_96 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_97 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_8 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_67,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_67));
    this._pipe_translate_11 = new import22.TranslatePipe(this.parentView.injectorGet(import24.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._el_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._text_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._el_75,
      this._text_76,
      this._el_77,
      this._text_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._text_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._anchor_94,
      this._text_95,
      this._text_96,
      this._text_97
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (94 === requestNodeIndex))) { return this._TemplateRef_94_5; }
    if (((token === import25.NgIf) && (94 === requestNodeIndex))) { return this._NgIf_94_6.context; }
    if (((token === import19.FormModalComponent) && ((92 <= requestNodeIndex) && (requestNodeIndex <= 95)))) { return this._FormModalComponent_92_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_92_0_0:any = this.context.title;
    this._FormModalComponent_92_3.check_title(currVal_92_0_0,throwOnChange,false);
    const currVal_92_0_1:any = this.context.name;
    this._FormModalComponent_92_3.check_name(currVal_92_0_1,throwOnChange,false);
    this._FormModalComponent_92_3.ngDoCheck(this,this._el_92,throwOnChange);
    const currVal_94_0_0:any = this.context.generalValues;
    this._NgIf_94_6.check_ngIf(currVal_94_0_0,throwOnChange,false);
    this._NgIf_94_6.ngDoCheck(this,this._anchor_94,throwOnChange);
    this._vc_94.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_103:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.GENERAL_CONFIG')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_103,currVal_103))) {
      this.renderer.setText(this._text_9,currVal_103);
      this._expr_103 = currVal_103;
    }
    valUnwrapper.reset();
    const currVal_105:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.GENERAL_CONFIG.INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_105,currVal_105))) {
      this.renderer.setText(this._text_18,currVal_105);
      this._expr_105 = currVal_105;
    }
    valUnwrapper.reset();
    const currVal_107:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('restrictions.GENERAL_CONFIG.TABLE.header2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_107,currVal_107))) {
      this.renderer.setText(this._text_36,currVal_107);
      this._expr_107 = currVal_107;
    }
    valUnwrapper.reset();
    const currVal_109:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('restrictions.GENERAL_CONFIG.TABLE.header3')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_109,currVal_109))) {
      this.renderer.setText(this._text_40,currVal_109);
      this._expr_109 = currVal_109;
    }
    valUnwrapper.reset();
    const currVal_111:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('restrictions.GENERAL_CONFIG.TABLE.header4')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_111,currVal_111))) {
      this.renderer.setText(this._text_44,currVal_111);
      this._expr_111 = currVal_111;
    }
    valUnwrapper.reset();
    const currVal_113:any = import3.inlineInterpolate(2,'',this.context.generalValues.daysInAdvance,' ',((this.context.generalValues.daysInAdvance == 1)? valUnwrapper.unwrap(this._pipe_translate_5.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_6.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_113,currVal_113))) {
      this.renderer.setText(this._text_55,currVal_113);
      this._expr_113 = currVal_113;
    }
    valUnwrapper.reset();
    const currVal_116:any = import3.inlineInterpolate(2,'',this.context.generalValues.minRentalLength,' ',((this.context.generalValues.minRentalLength == 1)? valUnwrapper.unwrap(this._pipe_translate_7.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_8.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_116,currVal_116))) {
      this.renderer.setText(this._text_58,currVal_116);
      this._expr_116 = currVal_116;
    }
    valUnwrapper.reset();
    const currVal_119:any = import3.inlineInterpolate(2,'',this.context.generalValues.maxRentalLength,' ',((this.context.generalValues.maxRentalLength == 1)? valUnwrapper.unwrap(this._pipe_translate_9.transform('restrictions.DAY')): valUnwrapper.unwrap(this._pipe_translate_10.transform('restrictions.DAYS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_119,currVal_119))) {
      this.renderer.setText(this._text_61,currVal_119);
      this._expr_119 = currVal_119;
    }
    const currVal_122:any = this.context.hideActionButtons();
    if (import3.checkBinding(throwOnChange,this._expr_122,currVal_122)) {
      this.renderer.setElementProperty(this._el_67,'hidden',currVal_122);
      this._expr_122 = currVal_122;
    }
    valUnwrapper.reset();
    const currVal_123:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('common.EDIT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_123,currVal_123))) {
      this.renderer.setText(this._text_78,currVal_123);
      this._expr_123 = currVal_123;
    }
    this.compView_92.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_94.destroyNestedViews();
    this.compView_92.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 92) && (ngContentIndex == 0))) {
      cb(this._text_93,ctx);
      cb(this._vc_94.nativeElement,ctx);
      this._vc_94.visitNestedViewRootNodes(cb,ctx);
      cb(this._text_95,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 94)) { return new View_GeneralSettingsComponent1(this.viewUtils,this,94,this._anchor_94,this._vc_94); }
    return (null as any);
  }
  handleEvent_67(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.openFormModal($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/general-settings/general-settings.component.ngfactory.ts